import { Component, Input, OnInit } from '@angular/core';
import { PaymentScheduleTabName } from '../../../models/_enum-collections';
import { EventPaymentScheduleComponent } from '../../shared/event-payment-schedule-table/event-payment-schedule.component';

@Component({
  selector: 'app-events-payment-schedule-milestone2',
  templateUrl: './events-payment-schedule-milestone2.component.html',
  styleUrls: ['./events-payment-schedule-milestone2.component.scss'],
  standalone: true,
  imports: [EventPaymentScheduleComponent]
})
export class EventsPaymentScheduleMilestone2Component implements OnInit {
  @Input() selectedProgramOption!: string;
  tabName!: PaymentScheduleTabName;

  ngOnInit() {
    this.tabName = PaymentScheduleTabName.Milestone2;
  }
}
